'use client';

import React from 'react';
import { useScript } from '@app/scripts';
import NostoRecommendationsBlock from '@app/components/nosto/nosto-recommendations-block';
import cn from 'clsx';
import s from '../../collections/collection-recommendations/collection-recommendations.module.css';

type StoriesRecommendationProps = {
    storyHandle: string;
};

const StoriesRecommendations = ({
    storyHandle,
}: StoriesRecommendationProps) => {
    const { nostoInitialised } = useScript();
    if (!nostoInitialised) return null;

    return (
        <article className={cn(s.root, s.stack)}>
            <NostoRecommendationsBlock
                placementIdentifier="stories-placement-1"
                pageKey={`stories_${storyHandle}`}
                type="stories"
                customRootClass={s.recommendationsBlock}
            />
        </article>
    );
};

export default StoriesRecommendations;
